import React from "react";
import { useSelector } from "react-redux";

const Header = () => {
    const { sdkConfig, cmsData } = useSelector((state) => state.userDetails);

    const { partnerLogoURL = "" } = sdkConfig;

    const logoUrl = cmsData?.logo?.url;

    return (
        <div className="Header">
            <div className="Header__logo">
                <img src={logoUrl} alt="logo" />
                {partnerLogoURL?.trim() && (
                    <div className="Header__logo__partner">
                        <span className="Header__logo__partner__hr"></span>
                        <img src={partnerLogoURL?.trim()} alt="logo" />
                    </div>
                )}
            </div>
        </div>
    );
};

Header.propTypes = {};

export default Header;
